import { render } from "./BoxLanding.vue?vue&type=template&id=3b559ab7&scoped=true"
import script from "./BoxLanding.vue?vue&type=script&lang=js"
export * from "./BoxLanding.vue?vue&type=script&lang=js"

import "./BoxLanding.vue?vue&type=style&index=0&id=3b559ab7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b559ab7"]])

export default __exports__